import api from './api';

export interface Project {
  id: string;
  name: string;
  description: string;
  language: string;
  user_id: string;
  created_at: string;
  updated_at: string;
}

export interface ProjectFile {
  id: string;
  name: string;
  path: string;
  content: string;
  language: string;
  file_type: 'file' | 'folder';
  project_id: string;
  parent_id: string | null;
  created_at: string;
  updated_at: string;
}

export const createProject = async (name: string, description: string = '', language: string = 'other'): Promise<Project> => {
  const response = await api.post('/api/projects', { name, description, language });
  return response.data;
};

export const getProjects = async (): Promise<Project[]> => {
  const response = await api.get('/api/projects');
  return response.data;
};

export const getProject = async (projectId: string): Promise<Project> => {
  const response = await api.get(`/api/projects/${projectId}`);
  return response.data;
};

export const updateProject = async (projectId: string, updates: Partial<Project>): Promise<Project> => {
  const response = await api.put(`/api/projects/${projectId}`, updates);
  return response.data;
};

export const deleteProject = async (projectId: string): Promise<void> => {
  await api.delete(`/api/projects/${projectId}`);
};

export const getProjectFiles = async (projectId: string): Promise<ProjectFile[]> => {
  const response = await api.get(`/api/projects/${projectId}/files`);
  return response.data;
};

export const createFile = async (projectId: string, fileData: { name: string; path: string; content?: string; language?: string; file_type?: 'file' | 'folder'; parent_id?: string }): Promise<ProjectFile> => {
  const response = await api.post(`/api/projects/${projectId}/files`, fileData);
  return response.data;
};

export const getFile = async (fileId: string): Promise<ProjectFile> => {
  const response = await api.get(`/api/projects/files/${fileId}`);
  return response.data;
};

export const updateFile = async (fileId: string, updates: Partial<ProjectFile>): Promise<ProjectFile> => {
  const response = await api.put(`/api/projects/files/${fileId}`, updates);
  return response.data;
};

export const deleteFile = async (fileId: string): Promise<void> => {
  await api.delete(`/api/projects/files/${fileId}`);
};
